var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.success = bind(this.success, this);
    var locations, ref1, ref2, ref3, ref4, ref5;
    this.query = '';
    this.env = opts.env || 'desktop';
    this.$container = opts.resultList;
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.endpoints = opts.endpoints;
    this.ctx = 'search';
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasBetterUx = opts.enableBetterUx;
    this.hasGeolocation = opts.enableGeolocation;
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    this.hasSearchCategories = opts.enableSearchCategories;
    if (opts.enableRecentSearches) {
      this.recentKeywords = getRecentSearches('deal');
      this.hasRecentSearches = ((ref3 = this.recentKeywords) != null ? ref3.length : void 0) > 0;
    }
    if (opts.enableRecentLocations) {
      locations = getRecentSearches('location');
      this.recentLocations = locations.filter(function(e) {
        return e.hasOwnProperty('division');
      });
      if (((ref4 = this.recentLocations) != null ? ref4.length : void 0) > 0) {
        if (this.recentLocations.length !== locations.length) {
          setRecentSearches(this.recentLocations, 'location');
        }
        if (typeof this.recentLocations[0] === 'object') {
          this.hasRecentLocations = true;
        } else {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            localStorage.removeItem('LS_recentLocations');
          }
        }
      }
    }
    if ((ref5 = Groupon.LS) != null ? ref5.hasTouch : void 0) {
      this.setBHViewport();
    }
  }


  /*
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1, ref2;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (query === this.query && ((ref1 = this.result) != null ? ref1.length : void 0)) {
      this.buildView(_.deepClone(this.result), query);
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.experiments['LS-2426-use-ell-for-relevance'] && ((ell = Cookie.get('ell')) != null)) {
        ref2 = ell.split(','), lat = ref2[0], lng = ref2[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /*
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /*
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.containers);
    this.$inputs.removeAttr('aria-activedescendant');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty();
  };


  /*
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    e.preventDefault();
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = query.trim();
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      this.fetch(query);
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

//# sourceMappingURL=data:application/json;base64,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
